import { playOrderAlert } from "./orderAlertAudio";
import { ORDER_BEHAVIOUR } from "../odsArchitecture/orderBehaviourConfig";

// ODS is disabled when it's turned off in configuration (per retail type) or
// when the logged-in user doesn't have the ODS_USER role — same conditions as
// the "Online Orders" tab guard in OrdersPage.
const isOdsAccessible = (retailType) => {
  const appConfigData = localStorage.getItem("appConfig");
  const appConfig = appConfigData ? JSON.parse(appConfigData) : {};
  const enabledDisplayModes = appConfig?.settings?.DISPLAY_SYSTEM_MODE?.kdsDisplayScreens;
  const isOdsEnabled = enabledDisplayModes?.find((mode) => mode === "ODS");
  const showOdsTab = JSON.parse(localStorage.getItem("orgConfig"))?.odsScreen || false;
  const isOdsUser = localStorage.getItem("user_roles")?.includes("ODS_USER") || false;

  const odsEnabled = retailType === "RESTAURANT" ? isOdsEnabled : showOdsTab;

  return Boolean(odsEnabled && isOdsUser);
};

export const handleOrderNotification = ({
  retailType,
  isDeliveryScreen,
  hasNewOrder,
  hasCreatedOrders,
  showPopup,
  setBlinkIcon,
}) => {
  const screenType = isDeliveryScreen ? "DELIVERY_SCREEN" : "NON_DELIVERY_SCREEN";
  const behavior = ORDER_BEHAVIOUR?.[retailType]?.[screenType];

  if (!behavior) return;

  if (behavior?.blinkIcon && setBlinkIcon) {
    setBlinkIcon(hasCreatedOrders);
  }

  if (!hasNewOrder) return;

  if (behavior?.playBuzzer && isOdsAccessible(retailType)) {
    playOrderAlert();
  }

  if (behavior?.showPopup && showPopup) {
    showPopup();
  }
};
